import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public hideComponents$ = new BehaviorSubject<boolean>(false);

  public hideViewLayout(value: boolean): void {
    this.hideComponents$.next(value);
  }
}
